// tslint:disable:max-line-length

import { ColorRecipeModel } from 'src/app/edit/models/color-recipe.model';
import { ScalarFresnelModel } from 'src/app/edit/models/scalar-fresnel.model';
import { PaintPresetModel } from 'src/app/edit/models/paint-preset.model';

enum PaintGroups {
  Colors = 'Colors', 
  Effects = 'Effects'
}

enum PaintIcons {
  Colors = '_color',
  Effects = 'adjust'
}

// Colors
export const PaintPresetOriginal = new PaintPresetModel('Original', new ColorRecipeModel({}), 'times-circle', PaintGroups.Colors);
export const PaintPresetRed = new PaintPresetModel('Red', new ColorRecipeModel({tintColor: [1, 0, 0]}), PaintIcons.Colors, PaintGroups.Colors);
export const PaintPresetYellow = new PaintPresetModel('Yellow', new ColorRecipeModel({tintColor: [1, 1, 0]}), PaintIcons.Colors, PaintGroups.Colors);
export const PaintPresetGreen = new PaintPresetModel('Green', new ColorRecipeModel({tintColor: [0, 1, 0]}), PaintIcons.Colors, PaintGroups.Colors);
export const PaintPresetCyan = new PaintPresetModel('Cyan', new ColorRecipeModel({tintColor: [0, 1, 1]}), PaintIcons.Colors, PaintGroups.Colors);
export const PaintPresetBlue = new PaintPresetModel('Blue', new ColorRecipeModel({tintColor: [0, 0, 1]}), PaintIcons.Colors, PaintGroups.Colors);
export const PaintPresetPink = new PaintPresetModel('Pink', new ColorRecipeModel({tintColor: [1, 0, 1]}), PaintIcons.Colors, PaintGroups.Colors);

// Effects
export const PaintPresetGrayscale = new PaintPresetModel('Grayscale', new ColorRecipeModel({saturation: -100}), PaintIcons.Effects, PaintGroups.Effects);
export const PaintPresetDesaturated = new PaintPresetModel('Desaturated', new ColorRecipeModel({saturation: -50}), PaintIcons.Effects, PaintGroups.Effects);
export const PaintPresetFade = new PaintPresetModel('Fade', new ColorRecipeModel({tintColor: [0, 0, 0], brightness: 55, saturation: -100, opacity: new ScalarFresnelModel({edge: 100, center: 0, edgeBias: 0, centerBias: 100, power: 1}) }), PaintIcons.Effects, PaintGroups.Effects);

// Paint Preset Set
export const PaintPresets = [
  PaintPresetOriginal,
  PaintPresetRed,
  PaintPresetYellow,
  PaintPresetGreen,
  PaintPresetCyan,
  PaintPresetBlue,
  PaintPresetPink,
  PaintPresetGrayscale,
  PaintPresetDesaturated,
  PaintPresetFade
];

